import React from 'react';
import PropTypes from 'prop-types';

// Icon
const AlcoholIcon = ({ className, width, height, fill, opacity }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 59 50"
  >
    <g>
      <path
        className="icon"
        fill={fill}
        opacity={opacity}
        d="M32.0065 44.7679C30.1702 46.6102 28.2146 47.9489 26.1396 48.7841C24.0646 49.5947 21.861 50 19.5289 50C16.5725 50 13.8915 49.3859 11.486 48.1577C9.09882 46.9049 7.05135 45.1732 5.3436 42.9624C3.63585 40.7271 2.31373 38.0865 1.37722 35.0405C0.459073 31.97 0 28.617 0 24.9816C0 21.3215 0.44071 17.9686 1.32213 14.9226C2.20355 11.8521 3.46141 9.2115 5.0957 7.00074C6.74837 4.78998 8.73156 3.0705 11.0453 1.8423C13.3774 0.6141 15.9757 0 18.8403 0C20.3277 0 21.7141 0.159666 22.9995 0.478998C24.2849 0.79833 25.4785 1.24048 26.5803 1.80545C27.6821 2.37042 28.6829 3.04593 29.5826 3.83198C30.5008 4.61803 31.3271 5.49005 32.0616 6.44805L29.9958 10.7959C29.6836 11.4837 29.2613 11.9135 28.7288 12.0855C28.2146 12.2329 27.6545 12.0609 27.0486 11.5696C26.4793 11.1029 25.9101 10.6731 25.3408 10.28C24.7716 9.86244 24.1564 9.50626 23.4953 9.2115C22.8526 8.89216 22.1365 8.64652 21.3469 8.47458C20.5573 8.30263 19.6483 8.21665 18.62 8.21665C16.8939 8.21665 15.3422 8.62196 13.965 9.43257C12.5878 10.2186 11.4125 11.3363 10.4393 12.7856C9.46608 14.2348 8.7132 16.0034 8.18067 18.0914C7.66651 20.1548 7.40943 22.4515 7.40943 24.9816C7.40943 27.7327 7.69406 30.1891 8.26331 32.3508C8.83256 34.5124 9.63134 36.3424 10.6597 37.8408C11.7063 39.3147 12.9642 40.4446 14.4332 41.2307C15.9023 41.9921 17.5366 42.3729 19.3361 42.3729C20.5481 42.3729 21.6315 42.2132 22.5864 41.8939C23.5596 41.55 24.5145 41.0833 25.451 40.4937V31.9455H21.2367C20.796 31.9455 20.4379 31.7735 20.1625 31.4296C19.9054 31.0857 19.7768 30.6681 19.7768 30.1769V24.7237H32.0065V44.7679Z"
      />
      <path
        className="icon"
        fill={fill}
        opacity={opacity}
        d="M59 0.55269V8.2535H44.7596V22.1076H56.6863V29.8084H44.7596V49.4842H37.4879V0.55269H59Z"
      />
    </g>
  </svg>
);

AlcoholIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  opacity: PropTypes.string,
};

AlcoholIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
  opacity: '1',
};

export default AlcoholIcon;
